import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// Warm-up ping: wake the API worker's isolate while the app is still booting
// and authenticating, so the first data fetch lands on a warm worker. In
// production the base is empty and this hits the same-origin Pages proxy.
// Fire-and-forget; failures are irrelevant.
fetch(`${import.meta.env.VITE_RECRUITING_API_BASE ?? 'http://localhost:8787'}/health`).catch(
  () => {},
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
